// AI Generated Component
import { Component, OnInit, Input } from '@angular/core';
import { StateService } from '@uirouter/core';
import { SpellingRepoService } from '@client/app/services/api/spelling-repo/spelling-repo.service';
import { QualityRepoService } from '@client/app/services/api/quality-repo/quality-repo.service';
import { LinksRepoService } from '@client/app/services/api/links-repo/links-repo.service';
import { MonEventService } from '@monsido/services/mon-event/mon-event.service';
import { SeoRepoService } from '@client/app/services/api/seo-repo/seo-repo.service';
import { PolicyRepoService } from '@client/app/services/api/policy-repo/policy-repo.service';
import { SessionService } from '@monsido/core/session/session.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { DateTimeService } from '@client/app/services/date-time/date-time.service';
import { QAImportantHighlightsService } from '@client/app/blocks/service/qa/important-highlights.service';
import { MON_MODULES } from '@monsido/core/constants/mon-modules.constant';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/services/ui-router-transition-service/ui-router-transition-service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import { MON_EVENTS } from '@monsido/core/constants/mon-events.constant';
import { SpellingPagesDialogComponent } from '@client/app/pages/qa/spellcheck/pages/spelling-pages-dialog.component';
import {
    PagesFromSeoIssuesComponent,
} from '@client/app/pages/seo/dialogs/pages-from-seo-issues/pages-from-seo-issues.component';
import {
    SeoDialogPagesWithDuplicateTitleComponent,
} from '@client/app/pages/seo/dialogs/pages-with-duplicate-title/seo-dialog-pages-with-duplicate-title.component';
import { LinkContentComponent } from '@client/app/pages/qa/broken-links/links/link-content/link-content.component';
import {
    PagesPolicyDialogLinksComponent,
} from '@client/app/pages/policy/dialogs/links/pages-policy-dialog-links.component';
import {
    PagesPolicyDialogPagesComponent,
} from '@client/app/pages/policy/dialogs/pages/pages-policy-dialog-pages.component';

@Component({
    selector: 'domain-dashboard-notifications',
    standalone: false,
    template: `
        <div class="card panel-monsido-card max-height d-flex flex-column">
            <mon-panel-header
                [pHeader]="'Important Notifications' | translate"
                [subHeader]="'For this domain' | translate">
            </mon-panel-header>
            <div class="card-body flex-grow-1">
                <mon-spinner [loading]="loading">
                    <table class="table table-fixed remove-border-on-first-row table-hover">
                        <thead class="hidden">
                        <tr>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngIf="showQA && spellingErrors.length && showSpelling"
                            [attr.aria-label]="'Misspelling affecting the most content' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer"
                                     (click)="openDialog('spellingPagesDialog', 'page-details', {word: spellingErrors[0], pageDetailTarget: 'misspellings'})">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'MISSPELLINGS'] | monIcons"
                                                 [monAriaText]="'Mispelling' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <p class="text-ellipsis mb-1">
                                            <span translate>Misspelling affecting the most content</span>:
                                        </p>
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf mt-1'>
                                            {{spellingErrors[0].word}}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showQA && data.pages_with_potential_misspellings > 0 && showSpelling"
                            [attr.aria-label]="'Potential misspellings' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer"
                                     (click)="goTo('base.customer.domain.qa.spellcheck.potential')"
                                     tabindex="0"
                                     role="button">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'POTENTIAL_MISSPELLINGS'] | monIcons"
                                                 [monAriaText]="'Potential Misspelling' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis text-nowrap">
                                        <div class='label label-info px-1 inner-b-smurf inner-t-smurf'>
                                            {{ data.potential_misspellings | monNumber }}
                                        </div>&nbsp;<span translate>Potential misspellings</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showQA && showBrokenLink"
                            [attr.aria-label]="'Broken link affecting most pages' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer"
                                     (click)="openDialog('linkContent', 'page-details', {link: brokenLink, type: brokenLinkType})">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'BROKEN_LINKS'] | monIcons"
                                                 [monAriaText]="'Broken Links' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <p class="text-ellipsis mb-1">
                                            <span>{{ brokenLinkText }}</span>:
                                        </p>
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf mt-1'>
                                            {{ brokenLink.url }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showQA && showBrokenImage"
                            [attr.aria-label]="'Broken image affecting most pages' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer"
                                     (click)="openDialog('linkContent', 'md', {link: brokenImage, type: brokenLinkType})">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'BROKEN_IMAGES'] | monIcons"
                                                 [monAriaText]="'Broken Images' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <p class="text-ellipsis mb-1">
                                            <span>{{ brokenImageText }}</span>:
                                        </p>
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf mt-1'>
                                            {{ brokenImage.url }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showSEO && seoError && seoError.pages_count > 0"
                            [attr.aria-label]="'Most common SEO checkpoint needing review' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer" (click)="openSEODialog()">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'SEO_CHECKPOINTS'] | monIcons"
                                                 [monAriaText]="'SEO Checkpoints' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <p class="text-ellipsis mb-1">
                                            <span translate>Most common SEO checkpoint needing review</span>:
                                        </p>
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf mt-1'>
                                            {{ seoError.name | translateSeoIssue }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showStatistics"
                            [attr.aria-label]="'Pages without Visits in last 6 months' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer" (click)="goToStatistics()">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'PAGES_WITHOUT_VISITS'] | monIcons"
                                                 [monAriaText]="'Pages without Visits' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf'>
                                            {{ pagesWithoutVisit }}
                                        </div>&nbsp;<span translate>Pages without Visits in last 6 months</span>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        <tr *ngIf="showPolicy && policyError"
                            [attr.aria-label]="'Most common policy violation on this domain' | translate">
                            <td>
                                <div class="d-flex align-items-center cursor-pointer" (click)="openPolicyDialog()">
                                    <icon-circle class="px-2"
                                                 [color]="'text-link'"
                                                 [icon]="['DOMAIN', 'COMMON_POLICY_VIOLATIONS'] | monIcons"
                                                 [monAriaText]="'Common policy violations' | translate">
                                    </icon-circle>
                                    <div class="text-ellipsis">
                                        <p class="text-ellipsis mb-1">
                                            <span translate>Most common policy violation on this domain</span>:
                                        </p>
                                        <div class='label label-danger px-1 inner-b-smurf inner-t-smurf'>
                                            {{ policyError.name }}
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </mon-spinner>
            </div>
        </div>
    `,
})
export class DomainDashboardNotificationsComponent implements OnInit {
    @Input() contentCount: any;
    @Input() pageCount: any;
    @Input() pdfCount: any;
    @Input() documentCount: any;

    loading: boolean = false;
    domainId: any;
    showStatistics: boolean = false;
    showQA: boolean = false;
    showSEO: boolean = false;
    showPolicy: boolean = false;
    showSpelling: boolean = false;

    spellingErrors: any[] = [];
    data: any = {};
    brokenLink: any = null;
    brokenImage: any = null;
    seoError: any = null;
    policyError: any = null;
    pagesWithoutVisit: any = 0;

    showBrokenLink: boolean = false;
    showBrokenImage: boolean = false;
    brokenLinkText: string = '';
    brokenImageText: string = '';
    brokenLinkType: string = '';

    constructor (
        private spellingRepoService: SpellingRepoService,
        private qualityRepoService: QualityRepoService,
        private linksRepoService: LinksRepoService,
        private monEventService: MonEventService,
        private seoRepoService: SeoRepoService,
        private policyRepoService: PolicyRepoService,
        private sessionService: SessionService,
        private stateService: StateService,
        private statsRepoService: StatsRepoService,
        private dateTimeService: DateTimeService,
        private qaImportantHighlightsService: QAImportantHighlightsService,
        private activeFeatureService: ActiveFeatureService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
        private pipeService: PipeService,
    ) {}

    ngOnInit (): void {
        const user = this.sessionService.me;
        this.showStatistics = false;
        this.showSpelling = this.activeFeatureService.isFeatureActivePure('qa_spellcheck');

        if (this.sessionService.domain !== null) {
            this.domainId = this.sessionService.domain.id;
            this.showStatistics =
                this.pipeService.get('hasAccess')(user, MON_MODULES.statistics) &&
                this.activeFeatureService.isFeatureActive('statistics', this.sessionService.domain) &&
                this.sessionService.domainGroup === null;
            this.showQA = this.pipeService.get('hasAccess')(user, MON_MODULES.qa);
            this.showSEO = this.pipeService.get('hasAccess')(user, MON_MODULES.seo) && this.activeFeatureService.isFeatureActivePure('seo_all');
            this.showPolicy = this.pipeService.get('hasAccess')(user, MON_MODULES.policies) &&
                this.pipeService.get('activeFeature')('global_policy') &&
                this.activeFeatureService.isFeatureActivePure('policies_all');

            this.setupPromises();
            this.brokenLinkText = this.qaImportantHighlightsService.getBrokenLinkText();
            this.brokenImageText = this.qaImportantHighlightsService.getBrokenImageText();
            this.brokenLinkType = this.qaImportantHighlightsService.getLinkSearchType();
        }
    }

    private setupPromises (): void {
        this.loading = true;
        const promises: Promise<any>[] = [];

        if (this.showQA) {
            promises.push(
                this.getLinks('not_image', 'dead').then((links: any) => {
                    this.brokenLink = links.length > 0 ? links[0] : null;
                    this.showBrokenLink = this.qaImportantHighlightsService.showBrokenLink(this.brokenLink);
                }, () => {}),
            );

            promises.push(
                this.getLinks('image', 'dead').then((images: any) => {
                    this.brokenImage = images.length > 0 ? images[0] : null;
                    this.showBrokenImage = this.qaImportantHighlightsService.showBrokenImage(this.brokenImage);
                }, () => {}),
            );

            promises.push(
                this.getQASummary().then((summary: any) => {
                    this.data = summary;
                }, () => {}),
            );

            promises.push(
                this.getSpellingErrors().then((spellingErrors: any) => {
                    this.spellingErrors = spellingErrors;
                }, () => {}),
            );
        }

        if (this.showSEO) {
            promises.push(
                this.getSEOIssues().then((pages: any) => {
                    this.seoError = pages.length > 0 ? pages[0] : null;
                }, () => {}),
            );
        }

        if (this.showStatistics) {
            promises.push(
                this.getPagesWithoutVisit().then((pages: any) => {
                    this.pagesWithoutVisit = pages.total;
                }, () => {}),
            );
        }

        if (this.showPolicy) {
            promises.push(
                this.getPolicies().then((policies: any) => {
                    if (policies.length > 0 && policies[0].matches_count > 0) {
                        this.policyError = policies[0];
                    }
                }, () => {}),
            );
        }

        Promise.all(promises).finally(() => {
            this.loading = false;
        });
    }

    private getQASummary (): Promise<any> {
        return this.qualityRepoService.getSummary({
            domainId: this.domainId,
        });
    }

    private getSpellingErrors (): Promise<any> {
        return this.spellingRepoService.getAllErrors({
            domainId: this.domainId,
            page: 1,
            page_size: 1,
            sort_by: 'html_pages_count',
            sort_dir: 'desc',
            classification: 'confirmed',
            page_fixed: false,
        });
    }

    private getLinks (type: string, status: string, sortBy?: string): Promise<any> {
        return this.linksRepoService.getAll({
            page: 1,
            page_size: 1,
            status: status,
            type: type,
            sort_by: sortBy || 'dead_on_pages_count',
            sort_dir: 'desc',
            page_fixed: false,
        } as any);
    }

    private getSEOIssues (): Promise<any> {
        return this.seoRepoService.getAll({
            page: 1,
            page_size: 1,
            sort_by: 'pages_count',
            sort_dir: 'desc',
        } as any);
    }

    private getPolicies (): Promise<any> {
        return this.policyRepoService.domainGetAll({
            domain_id: this.domainId,
            page: 1,
            page_size: 1,
            sort_by: 'matches_count',
            sort_dir: 'desc',
        });
    }

    private getPagesWithoutVisit (): Promise<any> {
        return this.statsRepoService.getPagesWithoutVisits({
            limit: 2,
            page: 1,
            domainId: this.domainId,
            from: this.dateTimeService.format(this.dateTimeService.substractDuration(undefined, 181, 'days'), 'YYYY-MM-DD'),
            to: this.dateTimeService.format(
                this.dateTimeService.endOf(
                    this.dateTimeService.substractDuration(undefined, 1, 'days'),
                    'days' as any,
                ),
                'YYYY-MM-DD',
            ),
        });
    }

    openSEODialog (): void {
        let dialog: any;

        switch (this.seoError.name) {
            case 'seo_duplicate_title':
                dialog = 'seoDialogPagesWithDuplicateTitle';
                break;
            default:
                dialog = PagesFromSeoIssuesComponent;
        }

        this.openDialog(dialog, 'lg', { issue: this.seoError, pageCount: this.pageCount });
    }

    openPolicyDialog (): void {
        if (this.policyError.subject === 'link') {
            this.openDialog('pagesPolicyDialogLinks', 'page-details', { policy: this.policyError });
        } else {
            this.openDialog('pagesPolicyDialogPages', 'page-details', {
                policy: this.policyError,
                pageCount: this.pageCount,
                contentCount: this.contentCount,
                pdfCount: this.pdfCount,
                documentCount: this.documentCount,
            });
        }
    }

    openDialog (target: string, size: string, attrs?: any): void {
        if (size.constructor === Object) {
            attrs = size;
            size = 'page-details';
        }

        if (target === 'spellingPagesDialog') {
            target = SpellingPagesDialogComponent as any;
        }
        if (target === 'linkContent') {
            target = LinkContentComponent as any;
        }
        if (target === 'pagesPolicyDialogLinks') {
            target = PagesPolicyDialogLinksComponent as any;
        }
        if (target === 'pagesPolicyDialogPages') {
            target = PagesPolicyDialogPagesComponent as any;
        }
        if (target === 'seoDialogPagesWithDuplicateTitle') {
            target = SeoDialogPagesWithDuplicateTitleComponent as any;
        }

        const params = {
            body: target,
            size: size,
            data: attrs,
        };

        this.monEventService.run(MON_EVENTS.LOAD_DIALOG, { params });
    }

    goToStatistics (): void {
        this.goTo('base.customer.domain.statistics.pages.withoutVisits');
    }

    goTo (state: string): void {
        return this.monUIRouterTransitionService.onTransitionFinished(
            () => {
                this.stateService.go(state);
            },
        );
    }
}
